import React from "react"; // Limitless Imports

import FooterTitle from "../footer-title/FooterTitle";
import { useGroupResponseTimeContext } from "../../../hooks/group-response-time/GroupResponseTimeContext";
import { useTranslation } from "../../../../common/hooks/translation/TranslationContext";

var convertMillisecondsToReadableFormat = function convertMillisecondsToReadableFormat(milliseconds, t) {
  if (milliseconds === 0 || !milliseconds) {
    return "".concat("15" + " ").concat(t("minutes"));
  }

  var minute = Math.floor(milliseconds / 1000 / 60);
  var hour = 0;

  if (minute > 60) {
    hour = Math.floor(minute / 60);

    if (hour <= 1) {
      return "".concat(hour, " ").concat(t("hour"));
    } else {
      return hour < 12 ? "".concat(hour, " ").concat(t("hours")) : "".concat(12, " ", t("hours"));
    }
  } else {
    if (minute <= 0) {
      return "15 ".concat(t("minutes"));
    } else if (minute === 1) {
      return "".concat(minute, " ").concat(t("minute"));
    } else {
      return "".concat(minute, " ").concat(t("minutes"));
    }
  }
};

var TimeSinceFooter = function TimeSinceFooter() {
  var _useGroupResponseTime = useGroupResponseTimeContext(),
      timeSince = _useGroupResponseTime.timeSince;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var time = React.useMemo(function () {
    return convertMillisecondsToReadableFormat(timeSince.time, t);
  }, [timeSince, t]);
  return /*#__PURE__*/React.createElement(FooterTitle, {
    title: t("The last question took an expert {0} to answer", time),
    position: "bottom"
  });
};

export default TimeSinceFooter;